import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Download, Trash2 } from "lucide-react";

export default function AdminLeadsPage() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("");

  const load = async () => {
    const { data } = await api.get(`/admin/leads${type ? `?type=${type}` : ""}`);
    setItems(data.items || []);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [type]);

  const exportCsv = async () => {
    const url = `${API}/admin/leads/export${type ? `?type=${type}` : ""}`;
    const token = localStorage.getItem("cc_token");
    const resp = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {}, credentials: "include" });
    const text = await resp.text();
    const blob = new Blob([text], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "leads.csv";
    a.click();
  };

  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/leads/${id}`); load(); };

  return (
    <div data-testid="admin-leads">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl text-cc-text mb-2">Lead Yönetimi</h1>
          <p className="text-sm text-cc-muted">Newsletter, Founding Guest, Contact</p>
        </div>
        <button onClick={exportCsv} className="cc-btn text-[10px] py-2" data-testid="export-leads"><Download size={14} /> CSV indir</button>
      </div>

      <div className="flex gap-3 mb-6">
        {[
          { v: "", l: "Tümü" },
          { v: "newsletter", l: "Newsletter" },
          { v: "founding_guest", l: "Founding Guest" },
          { v: "contact", l: "Contact" },
        ].map((f) => (
          <button key={f.v} onClick={() => setType(f.v)} data-testid={`lead-filter-${f.v || "all"}`}
            className={`text-xs uppercase tracking-overline px-3 py-2 border ${type === f.v ? "border-cc-sepia text-cc-sepia" : "border-admin-border text-cc-muted hover:text-cc-text"}`}>
            {f.l}
          </button>
        ))}
      </div>

      <div className="bg-white border border-admin-border">
        <table className="w-full text-sm">
          <thead className="bg-admin-bg/60 text-left">
            <tr><th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Tür</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">E-posta</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Ad</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Telefon</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Tarih</th>
                <th></th></tr>
          </thead>
          <tbody>
            {items.length === 0 ? <tr><td colSpan="6" className="px-4 py-6 text-cc-muted">Lead yok.</td></tr> :
              items.map((l) => (
                <tr key={l.id} className="border-t border-admin-border">
                  <td className="px-4 py-3"><span className="text-[10px] uppercase tracking-overline text-cc-sepia">{l.type}</span></td>
                  <td className="px-4 py-3">{l.email}</td>
                  <td className="px-4 py-3 text-cc-muted">{l.name || "—"}</td>
                  <td className="px-4 py-3 text-cc-muted">{l.phone || "—"}</td>
                  <td className="px-4 py-3 text-cc-muted text-xs">{l.created_at ? new Date(l.created_at).toLocaleDateString("tr-TR") : "—"}</td>
                  <td className="px-4 py-3 text-right"><button onClick={() => del(l.id)} className="text-cc-muted hover:text-red-600"><Trash2 size={14} /></button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
